import { useBasicGiftCardContext } from '@/src/common/contexts/BasicGiftCardContext'
import { SelectInput } from '@/src/common/components/elements/Forms/SelectWithLabel'
import { clearFormErrorForField } from '@/src/common/utilities/clearFormErrorForField'
import { inputHasError } from '@/src/common/utilities/inputHasError'
import { FormErrorDisplay } from '@/src/modules/build-a-card/FormErrorDisplay'
import { ValidationError } from 'yup'
import {
    CARRIER_FONT_HANDWRITTEN,
    CARRIER_FONT_STANDARD,
    HANDWRITTEN_FEE,
} from '@/src/modules/build-a-card/constants'
import { HeaderParagraphText } from '@/src/modules/build-a-card/StyledComponents'
import { SimpleFieldWrapper } from '@/src/modules/build-a-card/StepElement'

interface IHandwrittenProps {
    formErrors: ValidationError[]
    setFormErrors: Function
}

const HandwrittenInput = ({ formErrors, setFormErrors }: IHandwrittenProps) => {
    const { fontSelection, setFontSelection } = useBasicGiftCardContext()
    const fontOptions = [
        {
            label: 'Standard:',
            value: CARRIER_FONT_STANDARD,
            blueText: 'FREE',
        },
        {
            label: 'Handwritten:',
            value: CARRIER_FONT_HANDWRITTEN,
            blueText: `$${HANDWRITTEN_FEE}`,
        },
    ]

    return (
        <SimpleFieldWrapper>
            <HeaderParagraphText>Choose your font:</HeaderParagraphText>
            <SelectInput
                defaultValue={fontSelection}
                value={fontSelection}
                options={fontOptions}
                onValueChange={(value: string) => {
                    setFontSelection(value)
                    clearFormErrorForField({
                        path: 'font',
                        formErrors: formErrors,
                        setFormErrors: setFormErrors,
                    })
                }}
                hasError={inputHasError(formErrors, 'font')}
                width={300}
            />
            <FormErrorDisplay formErrors={formErrors} path={'font'} />
        </SimpleFieldWrapper>
    )
}

export default HandwrittenInput
